import { Inject, Injectable, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Product } from '@interfaces/product';
import { BehaviorSubject, Observable, Subject, timer } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CompareService implements OnDestroy {

    private destroy$: Subject<void> = new Subject();


    constructor(private http: HttpClient) {}

    add(param): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/compares/add-product`, param);
    }

    remove(param): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/compares/remove-product`, param);
    }

    getAll(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/compares/`);
    }

    getType(type): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/compares/?type=${type}`);
    }

    clearType(param): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/compares/clear-type`, param);
    }

    clearAll(): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/compares/clear-all`, {});
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
